import MobileDetect from 'mobile-detect';

export class BrowserFeatureDetector {
    private static readonly md = new MobileDetect(window.navigator.userAgent);

    static isSystemTablet() {

        // if we aren't a tablet or phone, see how many touch points we have. 
        // If we have touch points, assume it is a tablet, becaue iPads on ios13 and up
        // make their user agent look like a mac.
        let navigator = window.navigator;
        if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
            return true;
        }

        return !!this.md.tablet();
    }
}
